import React from 'react'

import { Button } from '../../utils/shared/Button'
import { Translate } from '../translate/translate'

import * as S from './legal-representative-dialog.styles'

export type LegalRepresentativeDialogProps = {
  isOpen: boolean
  onConfirm: () => void
  onReject: () => void
}

export const LegalRepresentativeDialog = ({ isOpen, onConfirm, onReject }: LegalRepresentativeDialogProps) => {
  return (
    <S.Dialog open={isOpen}>
      <S.Title>
        <Translate>legal_representative_dialog.title</Translate>
      </S.Title>

      <S.DialogContent>
        <S.Description>
          <Translate>legal_representative_dialog.description</Translate>
        </S.Description>
      </S.DialogContent>

      <S.DialogActions>
        <Button onClick={onReject}>
          <Translate>legal_representative_dialog.reject</Translate>
        </Button>

        <Button onClick={onConfirm}>
          <Translate>legal_representative_dialog.confirm</Translate>
        </Button>
      </S.DialogActions>
    </S.Dialog>
  )
}
